import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CookieManagementService } from '../../account/services/cookie-management.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AppConfig } from '../../config-service/app.config';
import { cardTransactionServiceResModel } from '../models/cardTransactionsResponse.model';
import { VersionHelper } from '../../utility-packages/versionHelper/version-helper';

@Injectable()
export class CardTransactionService {
  accessToken = '';

  constructor(
    private http: HttpClient,
    private translate: TranslateService,
    private cookieManagementService: CookieManagementService,
    private toastr: ToastrService, 
    private versionHelper: VersionHelper,
  ) {}

  public getCardTransactionsResult(
    alias: string,
    termDate: string
  ): Observable<cardTransactionServiceResModel> {
    this.accessToken = this.cookieManagementService.getAccessToken();
    if (this.accessToken == '') {
      return new Observable<cardTransactionServiceResModel>();
    } else {
      this.accessToken = 'Bearer ' + this.accessToken;
      let headers = new HttpHeaders({
        'Content-Type': 'application/json',
        authorization: this.accessToken,
      });
      let url =
        AppConfig.settings.apiServer.url +
        'api/card/transaction?region=' +
        AppConfig.settings.city.region +
        '&version=' +
        this.versionHelper.getVersion() +
        '&lang=' +
        AppConfig.settings.apiServer.lang +
        '&authType=' +
        AppConfig.settings.apiServer.authType +
        '&alias=' +
        alias +
        '&term=' +
        termDate;

      return this.http
        .get<cardTransactionServiceResModel>(url, {
          headers: headers,
          responseType: 'json',
        })
        .pipe(
          catchError((error) => {
            if (typeof error === 'string') {
              return throwError(error);
            } else {
              return throwError(
                this.translate.instant('DEFAULT_ERROR_MESSAGE')
              );
            }
          })
        );
    }
  }
}

// curl --request GET \
//   --url 'https://service.kentkart.com/rl1/api/card/transaction?region=028&version=MOBILE_TEAM_TEST&lang=TR&authType=4&lat=37.069692&lng=37.376885&alias=0141155271&term=202101' \
//   --header 'Authorization: Bearer eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJrZW50a2FydC5jb20iLCJzdWIiOiIyMTQxMiIsImF1ZCI6InZGSkhTIiwiZXhwIjoxNjE3MTk0NDY5LCJuYmYiOjE2MTY1ODk2NjksImlhdCI6MTYxNjU4OTY2OSwianRpIjoiNDBjMjVhOTEtMzhmNC00MDdlLThiMjItNDk0NjE5YjY3YjVlIiwic2NvcGVzIjpbXX0.V5TWob8TrZXBlSxfW_TqTFYTdBbYMClResbvWo0iEEVrKaVdJaGGUcPFA_jQAb4c4hwzReQF9YvmkIocEWA90C2qT8k6y0V_hHS60ypgGyaJ-5KiPXXUF8Zz-h5-PRkyQ3Z8ghYeZ44vcpVjOib5wtwF0LCkux-NonOVhOAow0E' \
//   --cookie connect.sid=s%253ASXBKtyAMOMkpGrg--x29KyNXOijcFd9r.jlDhoS%252FREDHpXbxoqsRhl%252FPo8xSQe1sbuazM1Ffgvq0

// {
//     "result": {
//       "cmd": "/api/card/transaction",
//       "code": 0,
//       "message": "OK",
//       "dateTime": "20210325173448",
//       "debugTimeDiff": "",
//       "authType": "4"
//     },
//     "transactionList": [
//       {
//         "boardingDateTime": "20210128124220",
//         "description": "Kullanım",
//         "lineEndName": " ",
//         "lineStartName": "Kullanım",
//         "name": "Kullanım",
//         "routeCode": "-",
//         "usageAmt": "0.86",
//         "type": "1",
//         "unixtime": 1611826940,
//         "formattedDate": "28/01/2021 12:42",
//         "colorType": "0",
//         "checkInAmount": "",
//         "checkInFormattedDate": "",
//         "refundAmount": "",
//         "refundFormattedDate": ""
//       },
//       {
//         "boardingDateTime": "20210128114545",
//         "description": "Kullanım",
//         "lineEndName": " ",
//         "lineStartName": "Kullanım",
//         "name": "Kullanım",
//         "routeCode": "-",
//         "usageAmt": "2.15",
//         "type": "1",
//         "unixtime": 1611823545,
//         "formattedDate": "28/01/2021 11:45",
//         "colorType": "0",
//         "checkInAmount": "",
//         "checkInFormattedDate": "",
//         "refundAmount": "",
//         "refundFormattedDate": ""
//       },
//       {
//         "boardingDateTime": "20210128105037",
//         "description": "Kullanım",
//         "lineEndName": " ",
//         "lineStartName": "Kullanım",
//         "name": "Kullanım",
//         "routeCode": "-",
//         "usageAmt": "2.15",
//         "type": "1",
//         "unixtime": 1611820237,
//         "formattedDate": "28/01/2021 10:50",
//         "colorType": "0",
//         "checkInAmount": "",
//         "checkInFormattedDate": "",
//         "refundAmount": "",
//         "refundFormattedDate": ""
//       },
//       {
//         "boardingDateTime": "20210120220025",
//         "description": "Kullanım",
//         "lineEndName": " ",
//         "lineStartName": "Kullanım",
//         "name": "Kullanım",
//         "routeCode": "-",
//         "usageAmt": "1.75",
//         "type": "1",
//         "unixtime": 1611169225,
//         "formattedDate": "20/01/2021 22:00",
//         "colorType": "0",
//         "checkInAmount": "",
//         "checkInFormattedDate": "",
//         "refundAmount": "",
//         "refundFormattedDate": ""
//       },
//       {
//         "boardingDateTime": "20210119124527",
//         "description": "Kullanım",
//         "lineEndName": " ",
//         "lineStartName": "Kullanım",
//         "name": "Kullanım",
//         "routeCode": "-",
//         "usageAmt": "2.15",
//         "type": "1",
//         "unixtime": 1611049527,
//         "formattedDate": "19/01/2021 12:45",
//         "colorType": "0",
//         "checkInAmount": "",
//         "checkInFormattedDate": "",
//         "refundAmount": "",
//         "refundFormattedDate": ""
//       },
//       {
//         "datetime": "20210119105217",
//         "description": "Dolum",
//         "name": "Gaziulaş TVM Bayiliği",
//         "rfcardBalance": "21.88",
//         "rfcardOldBalance": "11.88",
//         "rtc": "3035021900E31F63D7F5B0E84ED6472BB405630E8BA62BF32EFB22220A02180A1F891E9BFD9B543EE807D367BA8DA19A6642089036B7DB",
//         "termNo": "00501",
//         "amount": "10",
//         "type": "0",
//         "subtype": "CH",
//         "isCancel": false,
//         "unixtime": 1611042737,
//         "formattedDate": "19/01/2021 10:52",
//         "colorType": "0"
//       },
//       {
//         "boardingDateTime": "20210119091620",
//         "description": "Kullanım",
//         "lineEndName": " ",
//         "lineStartName": "Kullanım",
//         "name": "Kullanım",
//         "routeCode": "-",
//         "usageAmt": "2.15",
//         "type": "1",
//         "unixtime": 1611036980,
//         "formattedDate": "19/01/2021 09:16",
//         "colorType": "0",
//         "checkInAmount": "",
//         "checkInFormattedDate": "",
//         "refundAmount": "",
//         "refundFormattedDate": ""
//       },
//       {
//         "boardingDateTime": "20210106182421",
//         "description": "Kullanım",
//         "lineEndName": " ",
//         "lineStartName": "Kullanım",
//         "name": "Kullanım",
//         "routeCode": "-",
//         "usageAmt": "2.15",
//         "type": "1",
//         "unixtime": 1609946661,
//         "formattedDate": "06/01/2021 18:24",
//         "colorType": "0",
//         "checkInAmount": "",
//         "checkInFormattedDate": "",
//         "refundAmount": "",
//         "refundFormattedDate": ""
//       },
//       {
//         "boardingDateTime": "20210106174851",
//         "description": "Kullanım",
//         "lineEndName": " ",
//         "lineStartName": "Kullanım",
//         "name": "Kullanım",
//         "routeCode": "-",
//         "usageAmt": "0.70",
//         "type": "1",
//         "unixtime": 1609944531,
//         "formattedDate": "06/01/2021 17:48",
//         "colorType": "0",
//         "checkInAmount": "",
//         "checkInFormattedDate": "",
//         "refundAmount": "",
//         "refundFormattedDate": ""
//       },
//       {
//         "boardingDateTime": "20210106170011",
//         "description": "Kullanım",
//         "lineEndName": " ",
//         "lineStartName": "Kullanım",
//         "name": "Kullanım",
//         "routeCode": "-",
//         "usageAmt": "2.15",
//         "type": "1",
//         "unixtime": 1609941611,
//         "formattedDate": "06/01/2021 17:00",
//         "colorType": "0",
//         "checkInAmount": "",
//         "checkInFormattedDate": "",
//         "refundAmount": "",
//         "refundFormattedDate": ""
//       }
//     ]
//   }
